import * as React from 'react';
import { useIntl } from 'react-intl';

import { useTitleStore } from 'src/stores/useTitleStore';
import { billableMetricsMessages } from 'src/features/billableMetrics/utils/messages';
import BillableMetricsTable from 'src/features/billableMetrics/components/tables/BillableMetricsTable';

const BillableMetricsLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(billableMetricsMessages.billableMetrics));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <BillableMetricsTable />;
};

export default BillableMetricsLayout;
